// extracted by mini-css-extract-plugin
module.exports =  {"ProductSizeFields":"ProductSizeFields__kPn1G"};